import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../../common/element/Table";
import Button from "../../../../common/element/Buttons";
import { useNavigate } from "react-router-dom";
import ArchiveModal from "../../../../common/Common/ArchiveModal";
import ThreeDotBouncingLoader from "../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import SweetAlertService from "../../../../common/SweetAlert/SweetAlert";
import { archiveCompany, clearArchiveCompany } from "../../../../redux/Companies/companiesSlice";
import {
    selectArchiveCompanyData,
    selectArchiveCompanyLoading,
    selectArchiveCompanyError,
} from "../../../../redux/Companies/companiesSelector";
import { selectUserData } from "../../../../redux/auth/authSelector";
import { ROLES } from "../../../../config/rolePermissions";
import CommonIconButton from "../../../../common/icons/CommonIconButton";
const { Tr, Th, Td, THead, TBody } = Table;

const CompaniesList = ({
    companyListData,
    onEdit,
    loading,
    onRefresh,
    showArchived = false,
    currentPage = 1,      // Add this prop
    itemsPerPage = 10     // Add this prop
}) => {
    const dispatch = useDispatch();
    const [mainCheck, setMainCheck] = useState(false);
    const [checkedItems, setCheckedItems] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [archiveAction, setArchiveAction] = useState('archive');
    const navigate = useNavigate();

    // Redux selectors
    const archiveData = useSelector(selectArchiveCompanyData);
    const archiveLoading = useSelector(selectArchiveCompanyLoading);
    const archiveError = useSelector(selectArchiveCompanyError);
    const userData = useSelector(selectUserData);
    const isAdmin = userData?.role_name === ROLES.ADMIN;

    // Calculate serial number base for current page
    const getSerialNumber = (index) => {
        return (currentPage - 1) * itemsPerPage + index + 1;
    };

    const onCheckboxChange = (checked, item) => {
        if (item === "mainCheck") {
            setMainCheck(checked);
            setCheckedItems(checked ? companyListData : []);
        } else {
            if (checked) {
                setCheckedItems([...checkedItems, item]);
            } else {
                setCheckedItems(checkedItems.filter((i) => i.id !== item.company_id));
            }
        }
    };

    // Handle archive button click
    const handleArchiveClick = (company, action = 'archive') => {
        setSelectedCompany(company);
        setArchiveAction(action);
        setIsOpen(true);
    };

    // Handle archive/unarchive confirmation - UPDATED to use new API
    const handleArchiveConfirm = () => {
        if (selectedCompany) {
            // Using the new API with isArchive parameter
            dispatch(archiveCompany({
                id: selectedCompany.company_id,
                isArchive: archiveAction === 'archive' // true for archive, false for unarchive
            }));
        }
    };

    // Handle successful archival/unarchival
    useEffect(() => {
        if (archiveData && !archiveLoading) {
            setTimeout(() => {
                const actionText = archiveAction === 'archive' ? 'archived' : 'unarchived';
                SweetAlertService.showSuccess({
                    title: "Success!",
                    message: archiveData?.message || `Company ${actionText} successfully`,
                    onConfirm: () => {
                        // Clear archive state
                        dispatch(clearArchiveCompany());

                        // Refresh the company list
                        if (onRefresh) {
                            onRefresh();
                        }

                        // Close modal and reset selected company
                        setIsOpen(false);
                        setSelectedCompany(null);
                        setArchiveAction('archive');
                    },
                });
            }, 200);
        }
    }, [archiveData, archiveLoading, dispatch, onRefresh, archiveAction]);

    // Handle archival error
    useEffect(() => {
        if (archiveError) {
            const actionText = archiveAction === 'archive' ? 'archive' : 'unarchive';
            SweetAlertService.showError({
                title: "Error!",
                message: archiveError || `Failed to ${actionText} company`,
            });
            // Clear error after showing
            dispatch(clearArchiveCompany());
        }
    }, [archiveError, dispatch, archiveAction]);

    return (
        <div className="border rounded-lg border-gray-200">
            <Table>
                <THead>
                    <Tr className="text-start">
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">S No.</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">Company Name</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">Contact Person</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">HR</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">HR Phone Number</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">HR Email Address</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">Status</Th>
                        <Th className="text-start font-lato font-medium text-sm leading-[1.5] text-[#475467]">Action</Th>
                    </Tr>
                </THead>

                <TBody>
                    {loading ? (
                        <Tr>
                            <Td colSpan={7} className="py-10 text-center">
                                <ThreeDotBouncingLoader />
                            </Td>
                        </Tr>
                    ) : companyListData?.length > 0 ? (
                        companyListData.map((item, index) => (
                            <Tr key={item.company_id} className="text-center">
                                <Td className="text-start font-lato font-medium text-sm leading-[1.5] text-[#1D2939]">
                                    {String(getSerialNumber(index)).padStart(2, "0")}
                                </Td>
                                <Td
                                    className="text-start cursor-pointer"
                                    onClick={() => {
                                        console.log("item.company_id", item.company_id);
                                        navigate(`/companies/companyview?companyId=${item.company_id}`);
                                    }}
                                >
                                    {item.company_name}
                                </Td>

                                <Td className="text-start">{item.contact_person}</Td>

                                <Td className="text-start">
                                    {`${item?.hr_user?.first_name || ""} ${item?.hr_user?.last_name || ""}`.trim() || "N/A"}
                                </Td>

                                <Td className="text-start">{item.hr_user?.mobile_number || "N/A"}</Td>
                                <Td className="text-start">{item.hr_user?.email || "N/A"}</Td>

                                <Td className="text-start">
                                    <span
                                        className={`inline-block px-3 py-1 text-sm font-medium rounded-full capitalize ${item.is_archived
                                                ? "bg-slate-100 text-slate-700"
                                                : "bg-green-100 text-green-800"
                                            }`}
                                    >
                                        {item.is_archived ? "Archived" : "Active"}
                                    </span>
                                </Td>

                                <Td>
                                    <div className="flex gap-1">
                                        {/* View Button */}
                                        <CommonIconButton
                                            type="view"
                                            onClick={() => {
                                                console.log("item.company_id", item.company_id);
                                                navigate(`/companies/companyview?companyId=${item.company_id}`);
                                            }}
                                        />


                                        {/* Edit Button - Only for Admin and Active Companies */}
                                        {isAdmin && !item.is_archived && (
                                            <CommonIconButton
                                            type="edit" onClick={() => onEdit(item)} className="w-10 h-10 flex items-center justify-center"/>
                                            
                                        )}

                                        {/* Archive/Unarchive Button - Only for Admin */}
                                        {isAdmin && (
                                            <CommonIconButton
                                                type={item.is_archived ? "unarchive" : "archive"}
                                                onClick={() => handleArchiveClick(item, item.is_archived ? 'unarchive' : 'archive')}
                                            />
                                          
                                        )}
                                    </div>
                                </Td>
                            </Tr>
                        ))
                    ) : (
                        <Tr>
                            <Td colSpan={7} className="text-center text-gray-500 py-6 text-sm">
                                No matching records found
                            </Td>
                        </Tr>
                    )}
                </TBody>
            </Table>

            <ArchiveModal
                dialogOpen={isOpen}
                onDialogClose={() => {
                    setIsOpen(false);
                    setSelectedCompany(null);
                    setArchiveAction('archive');
                }}
                onConfirm={handleArchiveConfirm}
                title={`Are you sure you want to ${archiveAction} this company?`}
                subtitle={
                    <>
                        {archiveAction === 'archive' ? 'Archiving' : 'Unarchiving'} "<strong>{selectedCompany?.company_name || 'this company'}</strong>"
                        will {archiveAction === 'archive' ? 'remove it from' : 'restore it to'} the active companies list.
                    </>
                }
                loading={archiveLoading}
            />
        </div>
    );
};

export default CompaniesList;
